export default {"src":"https://dap-gahrd5p1u-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};